import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
function About() {
  const [t] = useTranslation();
  return (
    <>
      <section
        className="about-area about-p pt-120 pb-120 p-relative fix"
        style={{ background: "#fcedf6" }}
      >
        <div className="animations-02">
          <img src="assets/img/bg/floating-logo.png" alt="contact-bg-an-01" />
        </div>

        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div
                className="s-about-img p-relative wow fadeInLeft animated"
                data-animation="fadeInLeft"
                data-delay=".4s"
              >
                <img src="assets/img/features/testabout2.png" alt="img" />
                <div className="about-text second-about">
                  <span>
                    18 <sub>+</sub>
                  </span>
                  <p>{t("home.YofE")}</p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12">
              <div
                className="about-content s-about-content pl-15 wow fadeInRight animated"
                data-animation="fadeInRight"
                data-delay=".4s"
              >
                <div className="about-title second-title pb-25">
                  <h5>
                    <i className="fas fa-graduation-cap" />{" "}
                    {t("home.smallTitle")}
                  </h5>
                  <h2>{t("home.bigTitle")}</h2>
                </div>
                <p className="txt-clr textjustify">{t("home.aboutp1")}</p>
                <p className="textjustify">{t("home.aboutp2")}</p>
                <div className="about-content2">
                  <div className="row">
                    <div className="col-md-12">
                      <ul className="green2">
                        <li>
                          <div className="abcontent">
                            <div className="ano">
                              <span>01</span>
                            </div>{" "}
                            <div className="text">
                              <h3>{t("home.prakticnoZnanje")}</h3>{" "}
                              <p>{t("prakticnoZnanje.tekst")}</p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="abcontent">
                            <div className="ano">
                              <span>02</span>
                            </div>{" "}
                            <div className="text">
                              <h3>{t("home.globalneMogucnosti")}</h3>{" "}
                              <p>{t("globalneMogucnosti.tekst")}</p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="slider-btn mt-20">
                  <Link
                    to="/svi-studijski-programi"
                    className="btn ss-btn smoth-scroll"
                  >
                    {t("header.SaznajVise")}{" "}
                    <i className="fal fa-long-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
